import { getAmenActivPreferences_2scale, getAmenActivPreferences_5scale, send_setPreferences, send_setRvDims} from './page-scripts/settings_scripts';
import { getFeatureFlags, featureFlagKeys, getAllFeatureFlags } from './util/general_util';
import { UserEnteredVehicle, editUserVehicleParams, vehicleTypeID } from './util/type_defs';
import { send_addVehicle, send_deleteUserVehicle, send_editVehicle, update_profile_settings } from './util/user_api';
import * as d3 from 'd3';
import { submitPreferenceSettings } from './util/dependentOnFeatureFlags';

$("#cancelSubForm").on("submit", function() {
	$(this).find("button[type='submit']").addClass("disabled");
});

export const init_ambassador_pointsBar = () => {
    $("[circleProgressBar]").each(function(i, element) {
        let points = parseInt($(element).attr("points"));

        let maxPoints = parseInt($(element).attr("maxPoints"));
		let percent:number;
		if (points > 300){
			percent = (maxPoints / maxPoints) * 100;
		}else{
			percent = (points / maxPoints) * 100;
		}


        let pie = d3.pie().value((d: number) => d).sort(null);

        let w = 300, h = 300;

        let outerRadius = w / 2 - 20;
        let innerRadius = 150;
        let color = ["#ececec", "#f48231", "#888888"];

        let arc = d3.arc()
            .innerRadius(innerRadius)
            .outerRadius(outerRadius)
            .startAngle(0)
            .endAngle(Math.PI);

        let arcLine = d3.arc()
            .innerRadius(innerRadius)
            .outerRadius(outerRadius)
            .startAngle(0);

        let svg = d3.select("#loyalty")
            .append("svg")
			.attr("viewBox", "0 0 300 150")
			.attr("preserveAspectRatio", "xMidYMid meet")
			.attr("style", "width: 100%; height: auto; max-width: 300px;")
            .append("g");

        let path = svg.append("path")
            .attr("d", arc)
            .attr("transform", "translate(" + w / 2 + "," + h / 2 + ") rotate(-90)")
            .style("fill", color[0]);

        let pathForeground = svg.append("path")
            .datum({ endAngle: 0 })
            .attr("d", arcLine)
            .attr("transform", "translate(" + w / 2 + "," + h / 2 + ") rotate(-90)")
            .style("fill", color[1]);

        let middleCount = svg.append("text")
            .datum(0)
            .text(d => d.toString())
            .attr("class", "middleText")
            .attr("text-anchor", "middle")
            .attr("transform", "translate(" + (w / 2 + 5) + "," + (h / 2.5 + 5) + ")")
            .style("fill", d3.rgb("#f48231").toString())
            .style("font-size", "72px");

        let oldValue = 0;

        let arcTween = function(transition: any, newValue: number, oldValue: number) {
            transition.attrTween("d", (d: any) => {
                let interpolate = d3.interpolate(d.endAngle, Math.PI * (newValue / 100));
                let interpolateCount = d3.interpolate(oldValue, newValue);

                return (t: number) => {
                    d.endAngle = interpolate(t);
                    middleCount.text(points.toString());
                    return arcLine(d);
                };
            });
        };

        pathForeground
            .transition()
            .duration(750)
            .ease(d3.easeCubic)
            .call(arcTween, percent, oldValue);
    });
};

if (window.location.pathname === "/userSettings") {
	$("#settingsPageNav").find('[data-bs-toggle="tab"]').on("shown.bs.tab", function() {
		const target = $(this).attr("href");
		setTimeout(()=>{
			$(document).scrollTop($(target).offset().top - 100);
		}, 500);
	});

	$(document).on("submit", "#add-vehicle-form", function(event) {
		event.preventDefault();
		let vehicleInfo:UserEnteredVehicle;
		let vehicleType:vehicleTypeID = $("#cust-rv-class").val() as vehicleTypeID;
		let make:string = $("#vehicle-make").val() as string;
		let model:string = $("#vehicle-model").val() as string;
		let length:number = $("#rv-length").val() as number;
		let width:number = $("#rv-width").val() as number;
		let height:number = $("#rv-height").val() as number;
		let length_in:number = $("#rv-length-in").val() as number;
		let width_in:number = $("#rv-width-in").val() as number;
		let height_in:number = $("#rv-height-in").val() as number;
		let driver_slideout:boolean = $("#driver-slideout").prop("checked");
		let passenger_slidout:boolean = $("#passenger-slideout").prop("checked");
		let rear_slidout:boolean = $("#rear-slideout").prop("checked");
		let isPrimary:boolean = $("#add-as-default").prop("checked");

		vehicleInfo = {
			vehicleTypeID: vehicleType,
			make:make,
			model:model,
			length:length,
			length_in:length_in,
			width:width,
			width_in:width_in,
			height:height,
			height_in:height_in,
			driver_slideout:driver_slideout,
			passenger_slideout:passenger_slidout,
			rear_slideout:rear_slidout,
			primary:isPrimary
		};
		$("#save-rv-spinner").show();
		send_addVehicle(vehicleInfo).then(vehicleResponse => {
			let oldAcctCompletion:number = parseInt($(".progress-circle").attr("stroke-dashoffset").toString());
			$("#rv").html(vehicleResponse.html);
			$(".progress-circle").each(function() {
				$(this).attr("stroke-dashoffset",vehicleResponse.dashoffset);
			});

			if (parseInt(vehicleResponse.dashoffset) < oldAcctCompletion) {
				$("#rigInfoComplete").removeClass("ai-circle-x");
				$("#rigInfoComplete").addClass("ai-circle-check-filled");
				$("#rigInfoComplete").css({"color":"#FF7700"});
			} else if (parseInt(vehicleResponse.dashoffset) > oldAcctCompletion) {
				$("#rigInfoComplete").removeClass("ai-circle-check-filled");
				$("#rigInfoComplete").addClass("ai-circle-x");
				$("#rigInfoComplete").css({"color":""});
			};

			$("#acctCompletionMsg").html("Your account is " + vehicleResponse.completionPercentage + "% complete!")

		}).catch(e => {
			$("#save-rv-spinner").hide();
		});
	});

	$(document).on("click", "[rem-vehicle]", function() {
		let vehicleID:string = $(this).attr("vehicleID");
		send_deleteUserVehicle(vehicleID).then(response => {
			let oldAcctCompletion:number = parseInt($(".progress-circle").attr("stroke-dashoffset").toString());
			$(`#remVehicleModal-${vehicleID}`).modal("hide");
			$("#rv").html(response.html);
			$(".progress-circle").each(function() {
				$(this).attr("stroke-dashoffset",response.dashoffset);
			});

			if (parseInt(response.dashoffset) < oldAcctCompletion) {
				$("#rigInfoComplete").removeClass("ai-circle-x");
				$("#rigInfoComplete").addClass("ai-circle-check-filled");
				$("#rigInfoComplete").css({"color":"#FF7700"});
			} else if (parseInt(response.dashoffset) > oldAcctCompletion) {
				$("#rigInfoComplete").removeClass("ai-circle-check-filled");
				$("#rigInfoComplete").addClass("ai-circle-x");
				$("#rigInfoComplete").css({"color":""});
			};

			$("#acctCompletionMsg").html("Your account is " + response.completionPercentage + "% complete!")

		}).catch(e => {
			$("#save-rv-spinner").hide();
		})
	});

	$(document).on("click", "#addVehicleBtn", function() {
		$("[href='#addCustomRV']").tab("show");
	});
	$(document).on("click","[viewVehicles]", function() {
		$("#rv-settings-main-disp").removeClass("d-none");
		$("[editVehiclePage").each(function(i,el) {
			if (!$(el).hasClass("d-none")) $(el).addClass("d-none");
		});
		$("[href='#userVehicleDisp']").tab("show");
	});
	$(document).on("click", "[showEditVehicle]", function() {
		let vehicleID:string = $(this).attr("vehicleID");
		$("#rv-settings-main-disp").addClass("d-none");
		$(`[editVehiclePage][vehicleID='${vehicleID}']`).removeClass("d-none");
	});

	$(document).on("click", "[saveVehicleEdits]", function() {
		let vehicleID:number = parseInt($(this).attr("vehicleID"));

		let vehicleEdits:editUserVehicleParams;
		let length:number = $(`#rv-length-${vehicleID}`).val() as number;
		let width:number = $(`#rv-width-${vehicleID}`).val() as number;
		let height:number = $(`#rv-height-${vehicleID}`).val() as number;
		let length_in:number = $(`#rv-length-in-${vehicleID}`).val() as number;
		let width_in:number = $(`#rv-width-in-${vehicleID}`).val() as number;
		let height_in:number = $(`#rv-height-in-${vehicleID}`).val() as number;
		let driver_slideout:boolean = $(`#driver-slideout-${vehicleID}`).prop("checked");
		let passenger_slidout:boolean = $(`#passenger-slideout-${vehicleID}`).prop("checked");
		let rear_slidout:boolean = $(`#rear-slideout-${vehicleID}`).prop("checked");
		let isPrimary:boolean|null = $(`#add-as-default-${vehicleID}`).prop("checked");

		if (isPrimary == undefined) isPrimary = null;

		vehicleEdits = {
			vehicleID:vehicleID,
			length:length,
			width:width,
			height:height,
			length_in:length_in,
			width_in:width_in,
			height_in:height_in,
			driver_slideout:driver_slideout,
			passenger_slideout:passenger_slidout,
			rear_slideout:rear_slidout,
			primary:isPrimary
		};

		send_editVehicle(vehicleEdits).then(vehicleHTML => {
			$("#rv").html(vehicleHTML);
		})
	});

	$(document).on("shown.bs.modal", "#cancelSubscriptionPopup", function() {
		window.setTimeout(function() {
			$("#cancelSubscriptionPopup").modal("hide");
		},15000);
	});

	$(document).on("click", "#cancelSub-nextBut", function() {
		$("#cancelSubscriptionPopup2 #page1").hide();
		$("#cancelSubscriptionPopup2 #page2").show();
		$(this).hide();
	});

	$(document).on("change", "[name='cancelReason']", function() {
		if ($(this).prop("checked")) {
			if ($(this).attr('id') == "other") {
				$("#other-text").prop("required",true);
			} else {
				$("#other-text").prop("required",false);
			};
		}
	});

	$(document).on("click", ".genieMatchSelector", function() {
			let el:JQuery<HTMLElement> = $(this);
			let amenityId = el.data("id");
			let preferenceLevel = el.data("level");

			let attributeType = el.attr("activitySelector") !== undefined ? "activitySelector" : el.attr("amenitySelector") !== undefined ? "amenitySelector" : null;

			// Remove the 'active' class from all buttons related to this amenity
			$(`.genieMatchSelector[${attributeType}][data-id=${amenityId}]`).removeClass("active");

			// Add the 'active' class to the clicked button
			el.addClass("active");

			// Update the preference text
			let preferenceTextElement = $(`[${attributeType}Text]h6[data-id="${amenityId}"]`);
			let preferenceText;
			if (preferenceLevel == 0) {
					preferenceText = "Don't Need";
			} else if (preferenceLevel == 1) {
					preferenceText = "Nice to Have";
			} else if (preferenceLevel == 2) {
					preferenceText = "Must Have";
			}
			preferenceTextElement.html(preferenceText);

			// Add the shake animation
			preferenceTextElement.addClass("shake");
			setTimeout(() => preferenceTextElement.removeClass("shake"), 1000);
	});




	$(document).on("change", ".amenity-pref", function() {
		let el:JQuery<HTMLElement> = $(this);
		if (el.is(":checked")) {
			let id:string = el.attr("id").replace(/\D/g,"");
			$(`#collapse-amenity-${id}`).collapse("show");
			$(".agRangeSlider#amenity-weight-am-" + id).css("opacity","100%");
		} else {
			let id:string = el.attr("id").replace(/\D/g,"");
			$(".agRangeSlider#amenity-weight-am-" + id).val("1");
			$(".agRangeSlider#amenity-weight-am-" + id).css("opacity","50%");
		};
	});
	$(document).on("change", ".activity-pref", function(){
		let el:JQuery<HTMLElement> = $(this);
		if (el.is(":checked")) {
			let id:string = el.attr("id").replace(/\D/g,"");
			$(`#collapse-activity-${id}`).collapse("show");
			$(".agRangeSlider#activity-weight-ac-" + id).css("opacity","100%");
		} else {
			let id:string = el.attr("id").replace(/\D/g,"");
			$(".agRangeSlider#activity-weight-ac-" + id).val("1");
			$(".agRangeSlider#activity-weight-ac-" + id).css("opacity","50%");
		};
	});

	//If a user updates a slider, but forgets to check the box for that amenity/activity, we should check it for them
	$(document).on("change",".agRangeSlider", function() {
		let el:JQuery<HTMLElement> = $(this);
		el.css("opacity","100%");
		if (el.attr("id").includes("amenity")) {
			let amenityID:String = el.attr("id").replace(/\D/g,"");
			$(".amenity-pref#am-" + amenityID).prop('checked',true);
		} else if (el.attr("id").includes("activity")) {
			let activityID:String = el.attr("id").replace(/\D/g,"");
			$(".activity-pref#ac-" + activityID).prop('checked',true);
		};
	});

	let initial_vals = [
		$("#account-fn").val().toString(),
		$("#account-ln").val().toString(),
		$("#account-email").val().toString(),
		$("#account-username").val().toString(),
		$("#account-city").val().toString(),
		$("#account-state").val().toString(),
		$("#account-zipcode").val().toString(),
		$("#account-postalcode").val().toString(),
		$("#account-address").val().toString(),
		$("#account-bio").val().toString(),
		$("#account-phone").val().toString(),
		// $("#account-interests").val().toString()
	];

	$("#submit-profile-settings").on("click", function() {
		let form:HTMLFormElement = (document.getElementById("accountSettingsForm") as HTMLFormElement);
		if (!form.checkValidity()) {
			form.reportValidity();
			return;
		};

		let new_vals = [
			$("#account-fn").val().toString(),
			$("#account-ln").val().toString(),
			$("#account-email").val().toString(),
			$("#account-username").val().toString(),
			$("#account-city").val().toString(),
			$("#account-zipcode").val().toString(),
			$("#account-postalcode").val().toString(),
			$("#account-address").val().toString(),
			$("#account-state").val().toString(),
			$("#account-bio").val().toString(),
			$("#account-phone").val().toString(),
			// $("#account-interests").val().toString()
		];
		let labels = [
			"f_name",
			"l_name",
			"username",
			"display_name",
			"home_city",
			"zipcode",
			"postalcode",
			"home_street_addr",
			"home_administrative_area_level_1",
			"bio",
			"phone"
			// "interests"
		];
		let ids = [
			"fn",
			"ln",
			"email",
			"username",
			"city",
			"zipcode",
			"postalcode",
			"address",
			"state",
			"bio",
			"phone",
			// "interests"
		];

		$("#save-userSettings-spinner").show();
		update_profile_settings(initial_vals, new_vals, labels).then(function(response) {
			let oldAcctCompletion:number = parseInt($(".progress-circle").attr("stroke-dashoffset").toString());
			Object.keys(response).forEach((key) => {
				let id:string = ids[labels.indexOf(key)];
				if (key == "dashoffset") {
					$(".progress-circle").each(function() {
						$(this).attr("stroke-dashoffset",response[key]);
					});

					if (parseInt(response[key]) < oldAcctCompletion) {
						$("#profileInfoComplete").removeClass("ai-circle-x");
						$("#profileInfoComplete").addClass("ai-circle-check-filled");
						$("#profileInfoComplete").css({"color":"#FF7700"});
					} else if (parseInt(response[key]) > oldAcctCompletion){
						$("#profileInfoComplete").removeClass("ai-circle-check-filled");
						$("#profileInfoComplete").addClass("ai-circle-x");
						$("#profileInfoComplete").css({"color":""});
					};

					$("#acctCompletionMsg").html("Your account is " + response["completionPercentage"] + "% complete!")

					initial_vals = [
						$("#account-fn").val().toString(),
						$("#account-ln").val().toString(),
						$("#account-email").val().toString(),
						$("#account-username").val().toString(),
						$("#account-city").val().toString(),
						$("#account-state").val().toString(),
						$("#account-zipcode").val().toString(),
						$("#account-postalcode").val().toString(),
						$("#account-address").val().toString(),
						$("#account-bio").val().toString(),
						$("#account-phone").val().toString(),
						// $("#account-interests").val().toString()
					];
				};
			});
			setTimeout(function() {$("#save-userSettings-spinner").hide();},500);

		}).catch(e => {
			$("#save-userSettings-spinner").hide();
			const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
			$("#errorModal").modal("show");
		});
	});

	$(document).on("click", "#submit-rv-settings", function() {
		let valid:boolean = (document.getElementById("rv-dim-form") as HTMLFormElement).checkValidity();
		if (!valid) {
			(document.getElementById("rv-dim-form") as HTMLFormElement).reportValidity();
			return;
		};
		let length:number = ($("#rv-length").val() as number);
		let width:number = ($("#rv-width").val() as number);
		let height:number = ($("#rv-height").val() as number);

		$("#save-rv-spinner").show();
		send_setRvDims(length,width,height).then((response) => {
			let oldAcctCompletion:number = parseInt($(".progress-circle").attr("stroke-dashoffset").toString());
			setTimeout(function(){$("#save-rv-spinner").hide();},500);
			$(".progress-circle").each(function() {
				$(this).attr("stroke-dashoffset",response.dashoffset);
			});

			if (parseInt(response.dashoffset) < oldAcctCompletion) {
				$("#rigInfoComplete").removeClass("ai-circle-x");
				$("#rigInfoComplete").addClass("ai-circle-check-filled");
				$("#rigInfoComplete").css({"color":"#FF7700"});
			} else if (parseInt(response.dashoffset) > oldAcctCompletion) {
				$("#rigInfoComplete").removeClass("ai-circle-check-filled");
				$("#rigInfoComplete").addClass("ai-circle-x");
				$("#rigInfoComplete").css({"color":""});
			};

			$("#acctCompletionMsg").html("Your account is " + response.completionPercentage + "% complete!")

		}).catch(e => {
			const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
			$("#errorModal").modal("show");
		});
	});

	$(document).on("click", "#submit-preference-settings", function() {
		if (window.featureFlags == undefined || window.featureFlags.preferencesNumOptions == undefined) {
			getAllFeatureFlags().then(() =>{
				submitPreferenceSettings(this);
			})
		}else{
			submitPreferenceSettings(this);
		}
	});

	$(document).on("click","#submit-email-settings", function() {
		$("#email_opt_form").submit();
	});


	init_ambassador_pointsBar();

};
